import { render, staticRenderFns } from "./ExistingTaxiV2.vue?vue&type=template&id=10815d0b&"
import script from "./ExistingTaxiV2.vue?vue&type=script&lang=js&"
export * from "./ExistingTaxiV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports